import { BlockchainIcon } from "~/components/logos/blockchain";
import { Copy } from "~/components/site/copy";
import type { BlockchainId } from "~/lib/stablecoins.server";

type Stablecoin = "SBC" | "USDGLO";

type Deployment = Readonly<{
  chainId: BlockchainId;
  stablecoin: Stablecoin;
  deploymentId: string;
}>;

const deployments: Deployment[] = [
  {
    chainId: "ethereum",
    stablecoin: "SBC",
    deploymentId: "2DGiYExmo31IMyFewRuB1rMgiPp",
  },
  {
    chainId: "ethereum",
    stablecoin: "USDGLO",
    deploymentId: "2RQzVYXTpyYCw9aRPgUflADFNcn",
  },
  {
    chainId: "polygon",
    stablecoin: "SBC",
    deploymentId: "2G8Em8ZfZYA5a5Qg2IkqM7LjiPJ",
  },
  {
    chainId: "polygon",
    stablecoin: "USDGLO",
    deploymentId: "2RQzfsxVGEJGvdN3NmF12xrBolc",
  },
  {
    chainId: "solana",
    stablecoin: "SBC",
    deploymentId: "2Wa3LQY2s13QrhpN5aMfNH0C8R9",
  },
  {
    chainId: "stellar",
    stablecoin: "SBC",
    deploymentId: "2U4rCt6F98DMLXbGgiDBR8mB2YR",
  },
  {
    chainId: "base",
    stablecoin: "SBC",
    deploymentId: "2UOlODcZFFlHweO78LyRzPIT3G9",
  },
  {
    chainId: "optimism",
    stablecoin: "SBC",
    deploymentId: "2VcUu9c3HQ2rImn29oi6BwR8AGg",
  },
  {
    chainId: "avalanche",
    stablecoin: "SBC",
    deploymentId: "2CoiPjYT9E6yh1AewC0JalWIeNF",
  },
  {
    chainId: "celo",
    stablecoin: "SBC",
    deploymentId: "2Skb9oyeDBV2CVjYrUVNtqgs3OD",
  },
  {
    chainId: "celo",
    stablecoin: "USDGLO",
    deploymentId: "2Tf2i4hhuoUqtH7i18W0SyWBVY4",
  },
];

export function APIDeployments(): JSX.Element {
  return (
    <div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8">
      <table className="table-auto m-0">
        <thead>
          <tr>
            <th className="text-secondary">Chain</th>
            <th className="text-secondary">Stablecoin</th>
            <th className="px-8 text-secondary">ID</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deployments.map((d) => (
            <tr key={d.deploymentId}>
              <td>
                <BlockchainIcon
                  chainId={d.chainId}
                  className="mr-2 inline-block"
                />
              </td>
              <td className="whitespace-nowrap">
                {d.stablecoin === "SBC" ? (
                  <img
                    alt="Brale Stable Coin (SBC) logo"
                    src="/assets/stablecoins/sbc-logo.svg"
                    className="mr-2 inline-block w-6 h-6 m-0"
                  />
                ) : (
                  <img
                    alt="Glo Dollar (USDGLO) logo"
                    src="/assets/stablecoins/usdglo-logo.png"
                    className="mr-2 inline-block w-6 h-6 m-0"
                  />
                )}
                <span className="text-primary ml-2">{d.stablecoin}</span>
              </td>
              <td className="px-8 text-primary">{d.deploymentId}</td>
              <td className="text-right align-middle">
                <Copy value={d.deploymentId} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
